<template>
  <div class="image">
    <div class="container">
      <div class="row text justify-content-center">
        <div class="col-6 align-self-center">
          <h1 class="text-center">Wskazania</h1>
          <hr class="separator" />
          <ul>
            <li>bezinwazyjny lifting powiek górnych,</li>
            <li>redukcja zmarszczek nad górna wargą, tzw. “zmarszczek palacza”,</li>
            <li>redukcja zmarszczek na dolnej powiece,</li>
            <li>redukcja zmarszczek w kąciku oka tzw. “kurzych łapek”,</li>
            <li>leczenie wspomagające trądziku oraz usuwanie blizn potrądzikowych,</li>
            <li>usuwanie brodawek, włókniaków, kępek żółtych oraz plamek rubinowych,</li>
            <li>leczenie rozstępów oraz blizn pooperacyjnych</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'offer',
};
</script>

<style lang="scss" scoped>
@import '../../../../main.scss';

.text {
  color: $white;
  font-size: $font-size-base;
  h1 {
    color: white;
  }
}

.image {
    @extend .container-fluid;
    padding: 3rem 0;
    height: 80vh;
    min-height: 400px;
    background-image: url("../../../../assets/bg.jpg");
    background-size: 100% 100%;
    background-attachment: fixed;

    &:before {
      content: '';
    	position: absolute;
    	top: 0;
    	right: 0;
    	bottom: 0;
    	left: 0;
    	background-image: linear-gradient(to bottom right,$black,$black);
    	opacity: .6;
    }
}
</style>



// WEBPACK FOOTER //
// Offer.vue?c7ab70ee